import * as React from 'react';

export const useLoadStagedAutoReset = (
  newlyStagedItemId: string | null,
  setNewlyStagedItemId: (id: string | null) => void,
  delay = 500,
) => {
  React.useEffect(() => {
    if (!newlyStagedItemId) return;

    const timeout = setTimeout(() => {
      setNewlyStagedItemId(null);
    }, delay);

    return () => clearTimeout(timeout);
  }, [newlyStagedItemId, setNewlyStagedItemId, delay]);
};
